import { Text, Box, Layout, Card, InlineStack, Spinner } from '@shopify/polaris'
import { useSuspenseQueries } from '@tanstack/react-query'
import { reportQueryOptions } from '@/common/queries.ts'

const DashAnalytics = () => {
  const [{ data: report }] = useSuspenseQueries({
    queries: [reportQueryOptions()],
  })

  if (!report) {
    return <>Loading</>
  }

  return (
    <>
      <Layout.Section variant="oneHalf">
        <Card>
          <InlineStack align="space-between" blockAlign="start">
            <Box>
              <Text as="span" variant="bodyMd" fontWeight="medium">
                Total orders
              </Text>
            </Box>
          </InlineStack>
          <Box paddingBlockStart="100">
            {report?.total !== undefined ? (
              <Text as="p" variant="headingLg">
                {report?.total ?? 0}
              </Text>
            ) : (
              <Spinner size="small" />
            )}
          </Box>
        </Card>
      </Layout.Section>

      <Layout.Section variant="oneHalf">
        <Card>
          <InlineStack align="space-between" blockAlign="start">
            <Box>
              <Text as="span" variant="bodyMd" fontWeight="medium">
                Upcoming orders
              </Text>
            </Box>
          </InlineStack>
          <Box paddingBlockStart="100">
            {report?.scheduled !== undefined ? (
              <Text as="p" variant="headingLg">
                {report?.scheduled ?? 0}
              </Text>
            ) : (
              <Spinner size="small" />
            )}
          </Box>
        </Card>
      </Layout.Section>
    </>
  )
}

export default DashAnalytics
